import { useEffect } from "react";

const useStructuredData = (data: any) => {
    useEffect(() => {
        if (!data) {
            return;
        }

        removeEmptyProperties(data);

        const head = document.getElementsByTagName("head")[0];
        const script = document.createElement("script");

        script.type = "application/ld+json";
        script.id = data["@type"];
        script.innerHTML = JSON.stringify({
            "@context": "https://schema.org",
            ...data,
        });

        const existingScript = document.getElementById(script.id);
        existingScript?.parentNode?.removeChild(existingScript);

        head.appendChild(script);

        return () => {
            head.removeChild(script);
        };
    }, [data]);
};

export const removeEmptyProperties = (data: any) => {
    Object.keys(data).forEach(key => {
        if (data[key] && typeof data[key] === "object") {
            removeEmptyProperties(data[key]);
        } // recursive for objects
        else if (data[key] == null || data[key] === "") {
            delete data[key];
        } // remove empty properties
        if (typeof data[key] === "object" && Object.keys(data[key]).length === 0) {
            delete data[key];
        } // remove empty objects
    });
};

export default useStructuredData;
